<template>
  <Dialog
    v-model:visible="visible"
    :style="{
      maxWidth: wdth,
      width: 'calc(100% - 1rem)',
    }"
    :closable="false"
    :closeOnEscape="false"
    :modal="true"
    :draggable="false"
    class="p-2"
    pt:mask:class="!bg-[rgba(0,0,0,0.5)]"
  >
    <template v-if="!hideHead" #header>
      <div class="inline-flex w-full items-center justify-between gap-4">
        <slot name="header"></slot>
        <Button
          @click="close"
          icon="pi pi-times"
          severity="secondary"
          variant="text"
          rounded
        ></Button>
      </div>
    </template>
    <slot></slot>
    <slot name="footer"></slot>
  </Dialog>
</template>

<script setup lang="ts">
import { useModalManager } from "@/composables/useModalManager";
import Dialog from "primevue/dialog";
import { ref } from "vue";

const props = defineProps<{
  width?: string;
  hideHead?: boolean;
}>();

const { setActiveModal } = useModalManager();
const wdth = ref(props.width || "450px");
const visible = ref(false);
const close = () => {
  emit("update:visible", false);
  emit("close");
  setActiveModal(null);
};

const emit = defineEmits<{
  (e: "update:visible", value: boolean): void;
  (e: "close"): void;
}>();
</script>
